import { MdCancel } from 'react-icons/md';
import { useNavigate, useLocation } from "react-router-dom";

const NavModalComponent = ({toggleNav}) => {

    const location = useLocation();
    const navigate = useNavigate();
    const activeOption = location.pathname.split("/")[1].trim().length > 0 ? location.pathname.split("/")[1] : "home"

    const nav = (path) =>{
        navigate(path);
        toggleNav();
    }

    return ( 
        <div className='absolute  h-[100vh] w-[100vw] top-0 bg-primary flex items-center justify-center z-10'>
                    <div className=" h-full w-[30%] text-white ">
                        <div className='text-4xl flex justify-center mt-4 cursor-pointer hover:text-5xl transition-all duration-100' onClick={toggleNav}>
                            <MdCancel/>
                        </div>
                       <ul className='list-none h-[80%] flex flex-col items-center justify-center gap-[10px] font-poppins text-[35px] font-[360] cursor-pointer transition-all duration-500'>
                        <li className={`${activeOption == "home"? "font-[500]" : ""}  hover:font-[500]`} onClick={()=>{nav("/home")}}>Home</li>
                        <li className={`${activeOption == "portfolio"? "font-[500]" : ""} hover:font-[500]`} onClick={()=>{nav("/portfolio")}}>Portfolio</li>
                        <li className={`${activeOption == "contact"? "font-[500]" : ""} hover:font-[500]`} onClick={()=>{nav("/contact")}}>Contact</li>
                       </ul>
                    </div>
                </div>
     );
}
 
export default NavModalComponent;